import workbillLogo from '../assets/workbill_logo.png';

export default function BrandLogo({ className = '', alt = 'WorkBill logo' }) {
  return <img src={workbillLogo} alt={alt} className={className} />;
}
